import template from './obligation-funding-panel.html';
import controller from './obligation-funding-panel.controller';

let obligationFundingPanelComponent = {
  restrict: 'E',
  bindings: {
    project: '<',
    onChanged: '&'
  },
  template,
  controller
};

export default obligationFundingPanelComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/obligation-funding-panel/obligation-funding-panel.component.js